
import GwError from '~/patterns/molecules/error.vue';
import GwPageTitle from '~/patterns/molecules/page-title/page-title.vue';

export default {
    components: {
        GwError,
        GwPageTitle
    },
    layout: 'error',
    data() {
        return {
            entry: null,
            site: this.$config.site,
        };
    },
};
